import { diagnostic } from "modules/api/services";
import { DiagnosticView } from "modules/diagnostic/diagnostic-constants";

export function createDiagnostic(options = {}) {
  return diagnostic.post("/diagnostics", {
    type: "diagnostic",
    ...options
  });
}

export function getDiagnostic(diagnosticId) {
  return diagnostic.get(`/diagnostics/${diagnosticId}`);
}

export function getUserDiagnostics(userId) {
  return diagnostic.post(`/diagnostics/all/user/${userId}`);
}

export function getDiagnosticSessionAnswers(diagnosticId) {
  return diagnostic.post(`/diagnostics/session/${diagnosticId}/answers`);
}

export function submitDiagnosticSessionAnswer(answers, step, diagnosticId) {
  return diagnostic.post(`/diagnostics/session/${diagnosticId}/check/step`, {
    step,
    answers
  });
}

export function unblockDiagnosticSession(diagnosticId) {
  return diagnostic.post(`/diagnostics/session/${diagnosticId}/unblock`);
}

export function getQuestion(questionId) {
  return diagnostic.get(`/matrix/questions/${questionId}`);
}

export function getPainAreas(side = DiagnosticView.FRONT) {
  return diagnostic.post(`/matrix/areas/get/side`, { side });
}



// WEBPACK FOOTER //
// ./src/modules/api/diagnostic-effects.js